module.exports = __webpack_public_path__ + "img/manAndwomen.eae47a44.png";